// src/app/pages/may-day-signup/may-day-signup.component.ts
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EmailJsService } from '../../services/emailjs.service';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-may-day-signup',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule],
  templateUrl: './may-day-signup.component.html',
  styleUrls: ['./may-day-signup.component.css']
})
export class MayDaySignupComponent {

  signup = {
    name: '',
    email: '',
    phone: '',
    zip: '',
    county: '',
    registered: '',
    message: ''
  };

  isSubmitting = false;
  submitted = false;
  errorMessage = '';

  readonly michiganCounties = [
    'Alcona','Alger','Allegan','Alpena','Antrim','Arenac','Baraga','Barry',
    'Bay','Benzie','Berrien','Branch','Calhoun','Cass','Charlevoix','Cheboygan',
    'Chippewa','Clare','Clinton','Crawford','Delta','Dickinson','Eaton','Emmet',
    'Genesee','Gladwin','Gogebic','Grand Traverse','Gratiot','Hillsdale','Houghton',
    'Huron','Ingham','Ionia','Iosco','Iron','Isabella','Jackson','Kalamazoo',
    'Kalkaska','Kent','Keweenaw','Lake','Lapeer','Leelanau','Lenawee','Livingston',
    'Luce','Mackinac','Macomb','Manistee','Marquette','Mason','Mecosta','Menominee',
    'Midland','Missaukee','Monroe','Montcalm','Montmorency','Muskegon','Newaygo',
    'Oakland','Oceana','Ogemaw','Ontonagon','Osceola','Oscoda','Otsego','Ottawa',
    'Presque Isle','Roscommon','Saginaw','St. Clair','St. Joseph','Sanilac',
    'Schoolcraft','Shiawassee','Tuscola','Van Buren','Washtenaw','Wayne','Wexford'
  ];

  constructor(private emailJs: EmailJsService, private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.update(
      'May Day Voter Registration Event',
      'Sign up for the May Day Voter Registration Event with Lydia Christensen. Help register Michigan voters on May 1, 2026.',
      'may-day-signup'
    );
  }

  onSubmit(): void {
    this.isSubmitting = true;
    this.errorMessage = '';

    const templateParams = {
      name: this.signup.name,
      email: this.signup.email,
      zip: this.signup.zip,
      role: 'May Day Voter Registration Event',
      message: `Phone: ${this.signup.phone || 'Not provided'}\nCounty: ${this.signup.county || 'Not specified'}\nRegistered to vote: ${this.signup.registered}\nMessage: ${this.signup.message || 'None'}`,
      form_type: 'May Day Voter Registration Signup',
      submission_date: new Date().toLocaleString()
    };

    this.emailJs.sendEmail(templateParams, 'May Day Voter Registration Signup')
      .then(() => {
        this.submitted = true;
        this.isSubmitting = false;
      })
      .catch(() => {
        this.errorMessage = 'Something went wrong. Please try again or email us directly.';
        this.isSubmitting = false;
      });
  }

  resetForm(): void {
    this.signup = { name: '', email: '', phone: '', zip: '', county: '', registered: '', message: '' };
    this.submitted = false;
    this.errorMessage = '';
  }
}
